/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.CONNECTION_SALES_TYPES_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.connectionSalesTypes,
                (memo, connectionSalesTypes) => {
                    const { id } = connectionSalesTypes;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = connectionSalesTypes;
                    return memo;
                },
                state,
            );
        }
    },
);